import { defaultThemeSkin } from '@/common/http'
import { themes } from './registry'

export const DEFAULT_THEME = defaultThemeSkin || 'blackGold'

export { themes }

export function getTheme(name = DEFAULT_THEME) {
    return (Object.prototype.hasOwnProperty.call(themes, name) && themes[name]) || themes[DEFAULT_THEME] || Object.values(themes)[0]
}

export function getThemeImage(name = DEFAULT_THEME, path = '') {
    const theme = getTheme(name)
    return path.split('.').reduce((value, key) => value && value[key], theme.assets)
}

export function applyTheme(name = DEFAULT_THEME) {
    const theme = getTheme(name)
    const root = document.documentElement

    const previous = root.__appliedThemeVars || []
    previous.filter(key => !Object.prototype.hasOwnProperty.call(theme.cssVars, key)).forEach(key => root.style.removeProperty(key))
    root.setAttribute('data-theme', theme.name)
    if (theme.design) root.setAttribute('data-theme-design', theme.design)
    else root.removeAttribute('data-theme-design')
    Object.keys(theme.cssVars).forEach((key) => {
        root.style.setProperty(key, theme.cssVars[key])
    })
    root.__appliedThemeVars = Object.keys(theme.cssVars)

    return theme
}
